import { FallbackProps } from 'react-error-boundary';

// TODO: Spruce this up to UX standards (use pattern lib, mui, etc)

export default function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <div role='alert'>
      <p>We apologize, but something went wrong:</p>
      <pre>{error.message}</pre>
      <button onClick={resetErrorBoundary}>Please try again</button>
    </div>
  );
}
